module.exports = require("@flagship.io/js-sdk");